// Module
var code = "<mx-text-box ng-model=\"vm.value\" ng-required=\"::vm.filter.required\" data-label=\"{{::vm.filter.title}}\">\r\n</mx-text-box>";
// Exports
export default code;